module.exports = __webpack_public_path__ + "img/ch16_16_回家说不了.20e88aca.jpg";